import { ValidationErrors, FormGroup, FormControl, FormArray } from '@angular/forms';

export class CommonFormValidator {

    static checkzone(group: FormGroup): ValidationErrors | null {

        const sWind = group.get('projectWindloadZone')!.value;
        const sSchnee = group.get('projectSnowloadZone')!.value;
        const tCat = group.get('projectTerrain');
        let zoneError: boolean = false;

        if (sWind && sSchnee) {
            if (sWind == "1") {
                if (tCat?.value != '0') {
                    tCat?.setValue('0');
                }
            } else if (sWind == "2") {
                if (sSchnee == "2a") {
                    zoneError = true;
                }
            } else if (sWind == "3") {
                if (sSchnee == "2a" || sSchnee == "1a") {
                    zoneError = true;
                }
            } else if (sWind == "4") {
                if (sSchnee == "2a" || sSchnee == "1a") {
                    zoneError = true;
                }
            }
        }
        if (zoneError) {
            return { zoneMismatch: true };
        }
        return null;
    }

    static checkFileType(type: FormControl, v: any) {
        let fName = type.value.fileNames;
        let allowedTypes = ['jpeg', 'png', 'jpg'];
        if (fName) {
            let ext = fName.split('.').pop();
            if (!allowedTypes.includes(ext.toLowerCase())) {
                return { error: true };
            }
        }
        return null;
    }

    static checkDimension(group: FormArray): ValidationErrors | null {

        const bValue = group.controls[1].value;
        const cValue = group.controls[2].value;

        if (cValue >= bValue) {
            return { wrongDimension: true };
        }
        return null;
    }

}
